/* OrdinalLegend.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Fragment, useRef, useState } from 'react';
import useActiveSeriesKeyEmitter from '../../charts/common/events/hooks/useActiveSeriesKeyEmitter';
import { element, useElementProps } from '../../core/elements';
import { Layout } from '../container/layout';
import { gap100, gap200, legendMarkHeight, MAX_LEGEND_ENTRIES, symbolSize } from './constants';
import { useFlatData, useTruncationIndexObserver } from './utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _35 = "._1bsb1osq{width:100%}";
const _34 = "._2lx2vrvc{flex-direction:row}";
const _33 = "._i0dl1wug{flex-basis:auto}";
const _32 = "._gy1p7vkz{-moz-column-gap:1pc;column-gap:1pc}";
const _31 = "._4t3i1osq{height:100%}";
const _30 = "._19bv1crf{padding-left:9pt}";
const _29 = "._18u01wug{margin-left:auto}";
const _28 = "._otyr1wug{margin-bottom:auto}";
const _27 = "._2hwx1wug{margin-right:auto}";
const _26 = "._19pk1wug{margin-top:auto}";
const _25 = "._ae4v1y6m{align-content:flex-start}";
const _24 = "._2lx21bp4{flex-direction:column}";
const _23 = "._i0dl1r5k{flex-basis:30%}";
const _22 = "._1o9zidpf{flex-shrink:0}";
const _21 = "._16jlidpf{flex-grow:0}";
const _20 = "._1n261g80{flex-wrap:wrap}";
const _19 = "._1e0c116y{display:inline-flex}";
const _18 = "._o5721q9c{white-space:nowrap}";
const _17 = "._18m915vq{overflow-y:hidden}";
const _16 = "._1reo15vq{overflow-x:hidden}";
const _15 = "._1bto1l2s{text-overflow:ellipsis}";
const _14 = "._18u0idpf{margin-left:0}";
const _13 = "._otyrftgi{margin-bottom:8px}";
const _12 = "._2hwxidpf{margin-right:0}";
const _11 = "._19pkftgi{margin-top:8px}";
const _10 = "._1wyb1crf{font-size:9pt}";
const _9 = "._ect41wi2{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _8 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _7 = "._1ul9idpf{min-width:0}";
const _6 = "._4t3izwfg{height:2pc}";
const _5 = "._p12f1osq{max-width:100%}";
const _4 = "._zulpftgi{gap:8px}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1bah1h6o{justify-content:center}";
const _ = "._1e0c1txw{display:flex}";
export const legendLabelStyle = {
  color: "var(--ds-text-subtlest)",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  fontSize: '12px',
  margin: '8px 0px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
};
const LegendSymbol = _ref => {
  let {
    color,
    shape
  } = _ref;
  let symbol;
  switch (shape) {
    case 'square':
      symbol = /*#__PURE__*/_jsx("rect", {
        fill: color,
        width: symbolSize,
        height: symbolSize,
        rx: 1,
        ry: 1
      });
      break;
    case 'line':
      symbol = /*#__PURE__*/_jsx("line", {
        x1: 0,
        y1: symbolSize / 2,
        x2: symbolSize,
        y2: symbolSize / 2,
        stroke: color,
        strokeWidth: 2
      });
      break;
    case 'circle':
    default:
      symbol = /*#__PURE__*/_jsx("rect", {
        fill: color,
        width: symbolSize,
        height: symbolSize,
        rx: symbolSize / 2,
        ry: symbolSize / 2
      });
  }
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1e0c1txw _1bah1h6o _4cvr1h6o"]),
      children: /*#__PURE__*/_jsx("svg", {
        width: symbolSize,
        height: symbolSize,
        children: symbol
      })
    })]
  });
};
const VerticalLegendMark = _ref2 => {
  let {
    color,
    label,
    shape,
    opacity
  } = _ref2;
  const {
    emitActiveSeriesKey
  } = useActiveSeriesKeyEmitter();
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        opacity
      },
      onPointerEnter: e => emitActiveSeriesKey(e, label),
      onPointerLeave: e => emitActiveSeriesKey(e, undefined),
      className: ax(["_1e0c1txw _zulpftgi _p12f1osq _4t3izwfg _1ul9idpf"]),
      children: [/*#__PURE__*/_jsx(LegendSymbol, {
        color: color,
        shape: shape
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"]),
          children: label
        })]
      })]
    })]
  });
};
const HorizontalLegendMark = _ref3 => {
  let {
    color,
    label,
    shape,
    opacity
  } = _ref3;
  const {
    emitActiveSeriesKey
  } = useActiveSeriesKeyEmitter();
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _4, _6, _7]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        opacity
      },
      onPointerEnter: e => emitActiveSeriesKey(e, label),
      onPointerLeave: e => emitActiveSeriesKey(e, undefined),
      className: ax(["_1e0c116y _zulpftgi _4t3izwfg _1ul9idpf"]),
      children: [/*#__PURE__*/_jsx(LegendSymbol, {
        color: color,
        shape: shape
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18]
        }), /*#__PURE__*/_jsx("p", {
          className: ax(["_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"]),
          children: label
        })]
      })]
    })]
  });
};
function VerticalLegend(_ref4) {
  let {
    data,
    colorAccessor,
    colorScale,
    labelAccessor,
    shape,
    justifyContent = 'center',
    maxRows = 10
  } = _ref4;
  const legendRef = useRef(null);
  const [truncationIndex, setTruncationIndex] = useState(MAX_LEGEND_ENTRIES);
  const flatData = useFlatData({
    labelAccessor,
    data
  });
  useTruncationIndexObserver({
    legendRefCurrent: legendRef.current,
    setTruncationIndex
  });
  const itemsToTruncate = flatData.length - (truncationIndex || 0);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _2, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _16, _17, _32]
    }), /*#__PURE__*/_jsx("div", {
      ref: legendRef,
      style: {
        maxHeight: `${maxRows * legendMarkHeight + 2}px`,
        justifyContent
      },
      className: ax(["_1e0c116y _1bah1h6o _1n261g80 _16jlidpf _1o9zidpf _i0dl1r5k _2lx21bp4 _ae4v1y6m _19pk1wug _2hwx1wug _otyr1wug _18u01wug _19bv1crf _4t3i1osq _1reo15vq _18m915vq _gy1p7vkz"]),
      children: flatData.map((d, i) => /*#__PURE__*/_jsx(Fragment, {
        children: itemsToTruncate > 0 && truncationIndex - 1 <= i ? /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              position: 'relative'
            },
            children: [/*#__PURE__*/_jsx(VerticalLegendMark, {
              color: colorScale(colorAccessor(d)),
              label: labelAccessor(d),
              shape: shape,
              opacity: 0
            }, labelAccessor(d)), truncationIndex - 1 === i && /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  position: 'absolute',
                  top: 0,
                  left: 0
                },
                className: ax(["_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"]),
                children: ` ... ${itemsToTruncate + 1} more`
              })]
            })]
          })
        }) : /*#__PURE__*/_jsx(VerticalLegendMark, {
          color: colorScale(colorAccessor(d)),
          label: labelAccessor(d),
          shape: shape
        }, labelAccessor(d))
      }, `vertical-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    })]
  });
}
function HorizontalLegend(_ref5) {
  let {
    data,
    colorAccessor,
    colorScale,
    labelAccessor,
    shape,
    justifyContent = 'flex-start',
    maxRows = 5
  } = _ref5;
  const legendRef = useRef(null);
  const [truncationIndex, setTruncationIndex] = useState(MAX_LEGEND_ENTRIES);
  const flatData = useFlatData({
    labelAccessor,
    data
  });
  useTruncationIndexObserver({
    legendRefCurrent: legendRef.current,
    setTruncationIndex
  });
  const itemsToTruncate = flatData.length - (truncationIndex || 0);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _20, _21, _22, _33, _34, _25, _35, _16, _17, _32]
    }), /*#__PURE__*/_jsx("div", {
      ref: legendRef,
      style: {
        maxHeight: `${maxRows * legendMarkHeight + 2}px`,
        justifyContent
      },
      className: ax(["_1e0c116y _1n261g80 _16jlidpf _1o9zidpf _i0dl1wug _2lx2vrvc _ae4v1y6m _1bsb1osq _1reo15vq _18m915vq _gy1p7vkz"]),
      children: flatData.map((d, i) => /*#__PURE__*/_jsx(Fragment, {
        children: itemsToTruncate > 0 && truncationIndex - 1 === i ? /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              position: 'relative'
            },
            children: [/*#__PURE__*/_jsx(HorizontalLegendMark, {
              color: colorScale(colorAccessor(d)),
              label: labelAccessor(d),
              shape: shape,
              opacity: 0
            }, labelAccessor(d)), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  position: 'absolute',
                  top: 0,
                  left: 0
                },
                className: ax(["_syaz1jij _ect41wi2 _1wyb1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bto1l2s _1reo15vq _18m915vq _o5721q9c"]),
                children: ` ... ${itemsToTruncate + 1} more`
              })]
            })]
          })
        }) : /*#__PURE__*/_jsx(HorizontalLegendMark, {
          color: colorScale(colorAccessor(d)),
          label: labelAccessor(d),
          shape: shape
        }, labelAccessor(d))
      }, `horizontal-leged-entry${labelAccessor(d)}-${colorScale(colorAccessor(d))}-${i}`))
    })]
  });
}
function OrdinalLegend(_ref6) {
  var _layoutProps$gridTemp;
  let {
    data,
    colorAccessor,
    colorScale,
    labelAccessor,
    shape,
    maxRows,
    justifyContent,
    hide = false
  } = _ref6;
  const layoutProps = useElementProps(Layout);
  const sideBySide = !((_layoutProps$gridTemp = layoutProps.gridTemplate) !== null && _layoutProps$gridTemp !== void 0 && _layoutProps$gridTemp.includes('legend'));
  if (hide) return null;
  if (sideBySide) {
    return /*#__PURE__*/_jsx(VerticalLegend, {
      data: data,
      colorAccessor: colorAccessor,
      colorScale: colorScale,
      labelAccessor: labelAccessor,
      shape: shape,
      maxRows: maxRows,
      justifyContent: justifyContent
    });
  }
  return /*#__PURE__*/_jsx(HorizontalLegend, {
    data: data,
    colorAccessor: colorAccessor,
    colorScale: colorScale,
    labelAccessor: labelAccessor,
    shape: shape,
    maxRows: maxRows,
    justifyContent: justifyContent
  });
}
const _OrdinalLegend = element(OrdinalLegend);
export { _OrdinalLegend as OrdinalLegend };